/**
 * IMPORTANT
 *
 * If you're updating any values in this file make sure to update the same values
 * in the 'shadows.less' file as well.
 *
 * Both files should be sharing exactly same style properties.
 */
export const Shadows = [
    'none',
    '0 2px 4px 0 rgba(117,124,131,0.15)',
    '0 2px 12px 0 rgba(0,0,0,0.08)',
    '0 2px 33px 0 rgba(114,119,141,0.24)',
    '0 3px 22px 0 rgba(114,119,141,0.49)',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
];
//# sourceMappingURL=Shadows.constants.js.map